import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSection from '../components/sections/HeroSection';
import FeaturesSection from '../components/sections/FeaturesSection';
import UseCasesSection from '../components/sections/UseCasesSection';
import PricingPreview from '../components/sections/PricingPreview';
import IntegrationsSection from '../components/sections/IntegrationsSection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import FAQSection from '../components/sections/FAQSection';
import CTASection from '../components/sections/CTASection';
import { useTranslation } from '../hooks/useTranslation';
import { useSEO } from '../hooks/useSEO';

const LandingPage = () => {
  const { language } = useTranslation();
  useSEO('home');
  
  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      <main>
        <HeroSection />
        <FeaturesSection />
        <UseCasesSection />
        <PricingPreview />
        {language === 'en' && <IntegrationsSection />}
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;